document.addEventListener('DOMContentLoaded', function () {

  // ── CALCUL DYNAMIQUE DE LA HAUTEUR DU HEADER ──────────────────────
  function getHeaderHeight() {
    var selectors = [
      'header.header',
      '.header-wrapper',
      '#shopify-section-header',
      '.site-header',
      'header'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) {
        return Math.round(el.getBoundingClientRect().height);
      }
    }
    return 0;
  }

  // ── MISE À JOUR DU STICKY TOP ──────────────────────────────────────
  function updateStickyTop() {
    var headerHeight = getHeaderHeight();
    document.querySelectorAll('.tab-labels').forEach(function (tabLabel) {
      tabLabel.style.top = headerHeight + 'px';
    });
  }

  updateStickyTop();
  window.addEventListener('resize', updateStickyTop, { passive: true });

  // ── LOGIQUE DES ONGLETS ────────────────────────────────────────────
  var tabContainers = document.querySelectorAll('.product-tabs-wrapper');

  tabContainers.forEach(function (container) {
    var tabs     = container.querySelectorAll('.tab-label');
    var contents = container.querySelectorAll('.tab-content');

    if (!tabs.length || !contents.length) return;

    tabs[0].classList.add('active');
    contents[0].classList.add('active');

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('active'); });
        contents.forEach(function (c) { c.classList.remove('active'); });

        tab.classList.add('active');
        if (contents[index]) contents[index].classList.add('active');
      });
    });
  });

  // ── ACCORDÉONS : titres Description, sous-sections Conseils ──────
  function compleoToggleAccordion(item, bodyClass) {
    var body = item.querySelector(bodyClass);
    var chevron = item.querySelector('.acc-chevron');
    var isOpen = item.classList.contains('is-open');

    if (isOpen) {
      item.classList.remove('is-open');
      body.style.maxHeight = null;
      if (chevron) chevron.textContent = '+';
    } else {
      item.classList.add('is-open');
      body.style.maxHeight = body.scrollHeight + 'px';
      if (chevron) chevron.textContent = '−';
    }
  }

  document.addEventListener('click', function (e) {
    var accHead = e.target.closest('.acc-item-head');
    if (accHead) {
      var item = accHead.closest('.acc-item');
      if (item) compleoToggleAccordion(item, '.acc-item-body');
      return;
    }

    var plantHead = e.target.closest('.plant-card-head');
    if (plantHead) {
      var card = plantHead.closest('.plant-card');
      if (card) compleoToggleAccordion(card, '.plant-card-body');
      return;
    }

    var loadMoreBtn = e.target.closest('.faq-load-more-btn');
    if (loadMoreBtn) {
      var faqBlock = loadMoreBtn.closest('.tab-faq');
      if (faqBlock) {
        faqBlock.querySelectorAll('.acc-item--hidden').forEach(function (item) {
          item.classList.remove('acc-item--hidden');
        });
      }
      loadMoreBtn.closest('.faq-load-more-wrapper').style.display = 'none';
      return;
    }
  });

  // ── Ouvre automatiquement le 1er accordéon de chaque groupe ──────
  function compleoOpenFirstAccordions() {
    document.querySelectorAll('.acc-group').forEach(function (group) {
      var firstItem = group.querySelector('.acc-item');
      if (firstItem && !firstItem.classList.contains('is-open')) {
        firstItem.classList.add('is-open');
        var firstBody = firstItem.querySelector('.acc-item-body');
        if (firstBody) firstBody.style.maxHeight = firstBody.scrollHeight + 'px';
        var firstChevron = firstItem.querySelector('.acc-chevron');
        if (firstChevron) firstChevron.textContent = '−';
      }
    });
  }

  // ── Carte "Décrypté par Compléo" : masque la flèche en bas de scroll ──
  function compleoUpdateScrollFade() {
    document.querySelectorAll('.tab-right').forEach(function (scrollBox) {
      var fade = scrollBox.querySelector('.tab-right-fade');
      if (!fade) return;

      var atBottom = scrollBox.scrollTop + scrollBox.clientHeight >= scrollBox.scrollHeight - 4;
      var hasScroll = scrollBox.scrollHeight > scrollBox.clientHeight;

      if (atBottom || !hasScroll) {
        fade.classList.add('is-hidden');
      } else {
        fade.classList.remove('is-hidden');
      }
    });
  }

  document.querySelectorAll('.tab-right').forEach(function (scrollBox) {
    scrollBox.addEventListener('scroll', compleoUpdateScrollFade, { passive: true });
  });

  compleoUpdateScrollFade();
  window.addEventListener('resize', compleoUpdateScrollFade, { passive: true });
  document.addEventListener('shopify:section:load', compleoUpdateScrollFade);

  // ── Frise "Effets ressentis dans le temps" : le point s'arrête sur chaque carte à tour de rôle ──
  function compleoAnimateEffetsTimeline() {
    document.querySelectorAll('.effets-timeline-track').forEach(function (track) {
      var cards = track.querySelectorAll('.effet-card');
      var dot = track.querySelector('.effets-timeline-dot');
      if (!cards.length || !dot) return;

      var index = 0;

      function activate(i) {
        cards.forEach(function (c) { c.classList.remove('effet-card--active'); });
        var card = cards[i];
        card.classList.add('effet-card--active');
        var left = card.offsetLeft + card.offsetWidth / 2 - dot.offsetWidth / 2;
        dot.style.left = left + 'px';
      }

      activate(0);

      var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (prefersReducedMotion) return;

      setInterval(function () {
        index = (index + 1) % cards.length;
        activate(index);
      }, 2500);
    });
  }

  compleoAnimateEffetsTimeline();
  document.addEventListener('shopify:section:load', compleoAnimateEffetsTimeline);

  // ── Barre d'onglets compacte une fois collée en haut (sticky) ──────
  function compleoObserveStickyTabs() {
    var headerHeight = getHeaderHeight();
    document.querySelectorAll('.tab-labels').forEach(function (tabLabel) {
      if (tabLabel.dataset.stickyObserved) return;
      tabLabel.dataset.stickyObserved = 'true';

      var sentinel = document.createElement('div');
      sentinel.setAttribute('aria-hidden', 'true');
      sentinel.style.height = '1px';
      tabLabel.parentNode.insertBefore(sentinel, tabLabel);

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            tabLabel.classList.toggle('is-stuck', !entry.isIntersecting);
          });
        },
        { rootMargin: '-' + headerHeight + 'px 0px 0px 0px', threshold: 0 }
      );

      observer.observe(sentinel);
    });
  }

  compleoObserveStickyTabs();
  document.addEventListener('shopify:section:load', compleoObserveStickyTabs);

  // ── Filtre par catégorie sur l'onglet Composition ──────────────────
  function compleoInitCompositionFilters() {
    document.querySelectorAll('#compositionFilters').forEach(function (filterRow) {
      var pills = filterRow.querySelectorAll('.plant-pill');
      var grid = filterRow.nextElementSibling;
      if (!grid || !pills.length) return;
      var cards = grid.querySelectorAll('.plant-card');

      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          pills.forEach(function (p) { p.classList.remove('is-active'); });
          pill.classList.add('is-active');
          var category = pill.dataset.category;
          cards.forEach(function (card) {
            var show = category === 'all' || card.dataset.category === category;
            card.classList.toggle('is-hidden-filter', !show);
          });
        });
      });
    });
  }

  compleoInitCompositionFilters();
  document.addEventListener('shopify:section:load', compleoInitCompositionFilters);

  // ── Filtre par catégorie sur la section Best-sellers de la home ──
  function compleoInitBestsellersFilter() {
    document.querySelectorAll('#bestsellersPills').forEach(function (pillRow) {
      var pills = pillRow.querySelectorAll('.symptom-pill');
      var groupsWrapper = document.getElementById('bestsellersGroups');
      if (!groupsWrapper || !pills.length) return;
      var groups = groupsWrapper.querySelectorAll('.bestsellers-group');

      pills.forEach(function (pill) {
        pill.addEventListener('click', function (e) {
          e.preventDefault();
          pills.forEach(function (p) { p.classList.remove('symptom-pill--active'); });
          pill.classList.add('symptom-pill--active');
          var index = pill.dataset.index;
          groups.forEach(function (group) {
            group.classList.toggle('is-hidden-filter', group.dataset.index !== index);
          });
        });
      });
    });
  }

  compleoInitBestsellersFilter();
  document.addEventListener('shopify:section:load', compleoInitBestsellersFilter);

  // ── Défilement automatique en boucle continue de Best-sellers ────
  function compleoAutoScrollBestsellers() {
    document.querySelectorAll('.bestsellers-grid').forEach(function (grid) {
      if (grid.dataset.autoScrollInit) return;
      grid.dataset.autoScrollInit = 'true';

      var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (prefersReducedMotion) return;

      var originalItems = Array.prototype.slice.call(grid.querySelectorAll('.bestsellers-item'));
      var originalWidth = grid.scrollWidth;
      originalItems.forEach(function (item) {
        grid.appendChild(item.cloneNode(true));
      });

      setInterval(function () {
        if (grid.scrollLeft >= originalWidth - 5) {
          grid.scrollLeft = grid.scrollLeft - originalWidth;
        }

        var firstItem = grid.querySelector('.bestsellers-item');
        var itemWidth = firstItem ? firstItem.offsetWidth + 18 : 260;
        grid.scrollBy({ left: itemWidth, behavior: 'smooth' });
      }, 3500);
    });
  }

 compleoAutoScrollBestsellers();
  document.addEventListener('shopify:section:load', compleoAutoScrollBestsellers);

  // ── Points de pagination Best-sellers : un point par produit ──
  function compleoInitBestsellersDots() {
    document.querySelectorAll('.bestsellers-grid').forEach(function (grid) {
      if (grid.dataset.dotsInit) return;
      grid.dataset.dotsInit = 'true';

      var items = grid.querySelectorAll('.bestsellers-item');
      if (!items.length) return;

      var itemWidth = items[0].offsetWidth + 18;
      // Les produits sont dupliqués une fois par compleoAutoScrollBestsellers
      // pour l'effet de boucle infinie : on ne compte que les vrais.
      var realCount = Math.round(items.length / 2);

      var dotsWrapper = document.createElement('div');
      dotsWrapper.className = 'bestsellers-dots';

      for (var i = 0; i < realCount; i++) {
        (function (productIndex) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'bestsellers-dot' + (productIndex === 0 ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Aller au produit ' + (productIndex + 1));
          dot.addEventListener('click', function () {
            grid.scrollTo({ left: productIndex * itemWidth, behavior: 'smooth' });
            dotsWrapper.querySelectorAll('.bestsellers-dot').forEach(function (d) {
              d.classList.remove('is-active');
            });
            dot.classList.add('is-active');
          });
          dotsWrapper.appendChild(dot);
        })(i);
      }

      grid.insertAdjacentElement('afterend', dotsWrapper);
    });
  }

  compleoInitBestsellersDots();
  document.addEventListener('shopify:section:load', compleoInitBestsellersDots);

  /* ════════════════════════════════════════════════════════════════
     WIDGET AVIS JUDGE.ME — Homepage : mini-carte produit + points
     de pagination personnalisés. Verrouillé à .template-index pour
     ne jamais s'exécuter sur une autre page (catalogue, fiche
     produit), même si Judge.me venait à injecter son widget ailleurs.
     ════════════════════════════════════════════════════════════════ */
  (function () {
    function buildMiniProductCard(card) {
      if (card.querySelector('.jdgm-mini-product-card')) return;
      var stars = card.querySelector('.jdgm-stars');
      if (stars) card.insertBefore(stars, card.firstChild);

      var img = card.querySelector(':scope > img');
      var productName = card.querySelector('.jdgm-product-name');
      if (!img || !productName) return;

      var wrapper = document.createElement('div');
      wrapper.className = 'jdgm-mini-product-card';
      img.classList.add('jdgm-mini-product-thumb');
      wrapper.appendChild(img);
      wrapper.appendChild(productName);
      card.appendChild(wrapper);
    }

    function processAllCards(widget) {
      widget
        .querySelectorAll('.jdgm-card.jdgm-media-card')
        .forEach(buildMiniProductCard);
    }

    function getBlockId(widget) {
      var btn = widget.querySelector('.jdgm-arrow[onclick]');
      if (!btn) return null;
      var match = btn.getAttribute('onclick').match(/jdgm(?:Next|Previous)Card\('([^']+)'\)/);
      return match ? match[1] : null;
    }

    function buildDots(widget) {
      if (widget.querySelector('.jdgm-custom-dots')) return;
      var blockId = getBlockId(widget);
      var wrapper = widget.querySelector('.jdgm-cards-wrapper');
      var realCards = Array.prototype.slice
        .call(widget.querySelectorAll('.jdgm-card.jdgm-media-card'))
        .filter(function (c) {
          return !c.classList.contains('jdgm-clone-before') && !c.classList.contains('jdgm-clone-after');
        });
      if (!blockId || !wrapper || !realCards.length) return;

      var cardWidth = realCards[0].getBoundingClientRect().width + 18;
      var visiblePerPage = Math.max(1, Math.round(wrapper.getBoundingClientRect().width / cardWidth));
      var pageCount = Math.max(1, Math.ceil(realCards.length / visiblePerPage));

      var dotsWrapper = document.createElement('div');
      dotsWrapper.className = 'jdgm-custom-dots';

      for (var i = 0; i < pageCount; i++) {
        (function (pageIndex) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'jdgm-custom-dot' + (pageIndex === 0 ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Aller à la page ' + (pageIndex + 1));
          dot.addEventListener('click', function () {
            var activeCard = widget.querySelector('.jdgm-card.active');
            var currentIndex = activeCard ? parseInt(activeCard.dataset.cardIndex, 10) : 0;
            var targetIndex = pageIndex * visiblePerPage;
            var diff = targetIndex - currentIndex;
            var steps = Math.abs(diff);
            var fn = diff > 0 ? window.jdgmNextCard : window.jdgmPreviousCard;
            if (typeof fn !== 'function') return;
            for (var s = 0; s < steps; s++) fn(blockId);

            dotsWrapper.querySelectorAll('.jdgm-custom-dot').forEach(function (d) {
              d.classList.remove('is-active');
            });
            dot.classList.add('is-active');
          });
          dotsWrapper.appendChild(dot);
        })(i);
      }

      widget.appendChild(dotsWrapper);
    }

    function init() {
      var widget = document.querySelector('.jdgm-widget.jdgm-cards-carousel');
      if (!widget) return;
      processAllCards(widget);
      buildDots(widget);
    }

    var initialWidget = document.body.classList.contains('template-index')
      ? document.querySelector('.jdgm-widget.jdgm-cards-carousel')
      : null;
    if (initialWidget) {
      var observer = new MutationObserver(function () {
        init();
      });
      observer.observe(initialWidget, { childList: true, subtree: true });
      init();
    }
  })();
});